import { useAnalyticsApiClient } from "@/context/AnalyticsQueryLoaderProvider";
import { useQuery } from "@tanstack/react-query";
import { DataSource } from "@ternary/api-lib/analytics/enums";
import { billingFocusSchema } from "@ternary/api-lib/analytics/schemas/billingFOCUS";
import UError from "unilib-error";
import useBuildDataQuery from "../../../api/analytics/utils/useDataQuery";
import { UseQueryOptions, UseQueryResult } from "../../../lib/react-query";

const schemaName = billingFocusSchema.dimensions.subAccountID.schemaName;

type SubAccountDatum = {
  [schemaName]: string;
};

type Params = {
  dateRange: Date[];
};

export function useGetSubAccountIDsByTenantID(
  params: Params,
  options?: UseQueryOptions<string[], UError>
): UseQueryResult<string[], UError> {
  const client = useAnalyticsApiClient();

  const [tenantID, query] = useBuildDataQuery({
    dateRange: params.dateRange,
    dataSource: DataSource.FOCUS_BILLING,
    dimensions: [billingFocusSchema.dimensions.subAccountID],
  });

  return useQuery({
    queryKey: ["subAccountIDs", params],
    queryFn: async () => {
      const result = await client.loadData<SubAccountDatum>(tenantID, query);

      return result.response.reduce((accum: string[], _entry) => {
        if (!_entry[schemaName]) return accum;

        accum.push(_entry[schemaName]);

        return accum;
      }, []);
    },
    ...options,
  });
}
